<div>
  <app-weee-system-retail-vs-municipalities-vs-other-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)"></app-weee-system-retail-vs-municipalities-vs-other-filters>
  <mat-divider></mat-divider>
  <app-weee-system-retail-vs-municipalities-vs-other-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-weee-system-retail-vs-municipalities-vs-other-pie-chart>
</div>
